import { type FC, useEffect } from 'react';

import marketplace from '@atlassian/amkt-upm-spi-impl';

import { getMonitoringClient } from '@confluence/monitoring';

const contextPathFromPathname = window.location && window.location.pathname.split('/')[1];

export const CONTEXT_PATH = contextPathFromPathname ? `/${contextPathFromPathname}` : '/wiki';

type MarketplaceModuleProps = {
	cloudId: string;
};

export const MarketplaceModule: FC<MarketplaceModuleProps> = ({ cloudId }) => {
	useEffect(() => {
		try {
			const marketplaceModule = marketplace({
				product: 'confluence',
				cloudId,
				environment:
					process.env.NODE_ENV !== 'production'
						? 'unknown'
						: window.location.host.indexOf('.jira-dev.com') !== -1
							? 'staging'
							: window.location.host.indexOf('.atlassian.net') !== -1
								? 'prod'
								: 'unknown',
				baseUrl: `${window.location.protocol}//${window.location.host}${CONTEXT_PATH}`,
				gqlGatewayUrl: `${window.location.protocol}//${window.location.host}/gateway/api/graphql`,
			} as any);

			if (window.define) {
				window.define('ac/marketplace', marketplaceModule);
			}
		} catch (error) {
			getMonitoringClient().submitError(error, { attribution: 'ecosystem' });
		}
	}, [cloudId]);

	return null;
};
